import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CommonButton from '../../components/common/button/Button';
import CommonInput from '../../components/common/input/InputBox';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
        width: "100%"

    },
    '& .MuiDialog-paper': {
        // background: "linear-gradient(138deg, #D38C02 2.28%, rgba(255, 200, 94, 0.60) 81.66%), #FFF",
        background: "#FFFCC9",
        borderRadius: "20px",
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
    '& .MuiDialogTitle-root': {
        padding: theme.spacing(0.5),
    },

}));

interface ChangePasswordProps {
    open?: any;
    setOpen?: any;

}
const ChangePasswordDialogBox: React.FC<ChangePasswordProps> = ({ open, setOpen }) => {
    //@ts-ignore
    const config = window.config;
    const { t } = useTranslation("translation");
    const navigate = useNavigate();
    const apiBaseURL = config?.server || 'http://18.217.95.31:8080';
    const [newPassword, setNewPassword] = React.useState("");
    const [confirmNewPassword, setConfirmNewPassword] = React.useState("");
    const [helperText, setHelperText] = React.useState("");
    let localData = localStorage.getItem('UserData');
    const shopownerData = localData ? JSON.parse(localStorage.getItem('UserData') || "") : null;

    const handleClose = () => {
        setOpen(false);
    };


    const onHandleSubmit = () => {
        let body = {
            password: newPassword
        };
        axios.put(`${apiBaseURL}/api/users/changePassword?id=${shopownerData?.uId}`, body).then((data: any) => {
            localStorage.clear();
            navigate("/login")
            setOpen(false);
        }).catch((err: any) => {
            console.log("err", err)
        }).finally(() => {
            setOpen(false);
        })
    }


    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                maxWidth="sm"
            >
                <DialogTitle
                    sx={{ m: 0, color: "black", textAlign: "center", fontFamily: "IBM Plex Sans", fontWeight: "bolder" }}
                    id="customized-dialog-title">
                    {t("changePassword")}
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: "black"
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent>
                    <Grid container display="flex" justifyContent="center" spacing={2}>
                        <Grid item sm={8} lg={8} xs={8}>
                            <CommonInput
                                id={`password-input-box`}
                                fullWidth
                                className="white-input-box"
                                placeholder={t('newPassword')}
                                onChange={(e) => setNewPassword(e.target.value)}
                                label={t('newPassword')}
                                type="password"
                            />
                            <CommonInput
                                id={`confirm-password-input-box`}
                                fullWidth
                                type="password"
                                className="white-input-box"
                                placeholder={t('confirmNewPassword')}
                                onChange={(e) => setConfirmNewPassword(e.target.value)}
                                error={helperText? true:false}
                                helperText={helperText}
                                label={t('confirmNewPassword')}
                            />
                            <CommonButton
                                onClick={(e) => {
                                    if (newPassword === confirmNewPassword && newPassword) {
                                        setHelperText("")
                                        onHandleSubmit();
                                    }
                                    else {
                                        setHelperText(t("passwordNotMatched"));
                                    }
                                }
                                }
                                sx={{ height: "18%", color: "white", fontFamily: "Baloo 2", fontWeight: "900" }}
                            >
                                {t("sumbit")}
                            </CommonButton>
                        </Grid>
                    </Grid>

                </DialogContent>
            </BootstrapDialog>
        </React.Fragment>
    );
}
export default ChangePasswordDialogBox;